import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { AtmosphericBackground } from './components/effects/AtmosphericBackground';

// Critical pages loaded immediately
import { HomePage } from './pages/HomePage';

// Lazy load non-critical pages for better performance
const BooksPage = React.lazy(() => import('./pages/BooksPage').then(module => ({ default: module.BooksPage })));
const AuthorPage = React.lazy(() => import('./pages/AuthorPage').then(module => ({ default: module.AuthorPage })));
const CedarFallsPage = React.lazy(() => import('./pages/CedarFallsPage').then(module => ({ default: module.CedarFallsPage })));
const NewsPage = React.lazy(() => import('./pages/NewsPage').then(module => ({ default: module.NewsPage })));
const BookDetailPage = React.lazy(() => import('./pages/BookDetailPage').then(module => ({ default: module.BookDetailPage })));
const NotFoundPage = React.lazy(() => import('./pages/NotFoundPage').then(module => ({ default: module.NotFoundPage })));
const PrivacyPage = React.lazy(() => import('./pages/PrivacyPage').then(module => ({ default: module.PrivacyPage })));

// Loading component
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-forest-400"></div>
  </div>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-cedar-900 text-fog-200 relative overflow-x-hidden">
        {/* Lightweight atmospheric background */}
        <AtmosphericBackground />
        
        {/* Main app structure */}
        <div className="relative z-10">
          <Header />
          
          <main className="min-h-screen">
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/books" element={<BooksPage />} />
                <Route path="/books/:bookId" element={<BookDetailPage />} />
                <Route path="/cedar-falls" element={<CedarFallsPage />} />
                <Route path="/author" element={<AuthorPage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </main>
          
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;